import { FetchRootInvestmentsRequest } from './types';

export const GET_ENTITY_ROOT_INVESTMENTS = ({
  orgId,
  page = 1,
  limit = 15,
  investmentIds = [],
  incompleteFutureReportingPeriod = null,
  addChildren,
  addEntityRootInvestments,
  addTimePeriod
}: FetchRootInvestmentsRequest & {
  page: number;
  limit: number;
  addChildren: boolean;
  addEntityRootInvestments: boolean;
  addTimePeriod: boolean;
}) => {
  const params = new URLSearchParams();

  params.set('page', page.toString());
  params.set('limit', limit.toString());

  if (incompleteFutureReportingPeriod) {
    params.set('filter[incomplete_future_reporting_period]', 'true');
  }
  for (const investmentId of investmentIds) {
    params.append('filter[id][]', investmentId);
  }

  let include = 'entity';
  if (addTimePeriod) {
    include += ',timePeriod';
  }
  if (addChildren) {
    include += ',children';
  }
  if (addEntityRootInvestments) {
    include += ',entity.rootInvestments';
  }
  params.set('include', include);

  return `/base/organizations/${orgId}/pension-scheme?${params}`;
};
